export default class Event {
  public static COMPLETE: string = 'complete';

  public static CHANGE_SCALE: string = 'changeScale';

  public target: any;

  public type: string;

  constructor(type: string) {
    this.type = type;
  }
}
